import logo from '../images/logo.png';
import styled from 'styled-components';

const LogoContainer = styled.div`
    text-align: center;
    position: relative;
`;

const LogoBackground = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(212, 165, 116, 0.15) 0%, transparent 70%);
    z-index: -1;
`;

const Title = styled.h1`
    font-family: 'Noto Serif JP', serif;
    font-size: 48px;
    margin: 0 12px 0 0;
    display: inline-block;
    vertical-align: middle;
    font-weight: 300;
    color: #3E2723;
    letter-spacing: 8px;
`;

const Image = styled.img`
    width: 48px;
    vertical-align: middle;
    filter: sepia(0.3) hue-rotate(20deg);
    opacity: 0.9;
`;

export const Logo = () => (
    <LogoContainer>
        <LogoBackground />
        <Title>damascena</Title>
        <Image src={logo} alt="logo" />
    </LogoContainer>
);